module.exports = __webpack_public_path__ + "static/media/mobile-services-item-main-bg.3c216a77.svg";